/**
 * FAQ accordion configs / init
 * 
 * @package Hersey
 */

(function($) {
	$(document).ready(function() {

		// find accordion
		var faq = $( '.faq' );


		// check for faq page
		if ( $( 'body' ).hasClass( 'page-template-page-faq') && faq.length ) {

			faq.accordion({
				collapsible	: true,
				active		: false,
				heightStyle	: 'content',
			});
		}

	}); // document.ready
})(jQuery);